<template>
  
  <!-- Outer (Container Aspect Ratio) -->
  <div 
    ref     = "outer_container"
    class   = "outer-container"
  >

    <AnnotationToolsMenu 
      v-if    = "video.canPlay && ui.areAnnotationToolsShown"
      class   = "annotation-tools-menu"
    >
    </AnnotationToolsMenu>

    <!-- Inner (Video Aspect Ratio) -->
    <div
      ref     = "inner_container"
      class   = "inner-container"
      :style  = "innerContainerStyle"
    >

      <div class="elements">

        <VideoElement class="element">
        </VideoElement>

        <Overlays 
          v-if      = "video.canPlay && mediaHasVideo"
          class     = "element"
        >
        </Overlays>

        <AnnotationOverlay 
          v-if      = "video.canPlay"
          class     = "element"
        >
        </AnnotationOverlay>

      </div>

    </div>

  </div>

</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import AnnotationOverlay from './annotations/AnnotationOverlay.vue';
import AnnotationToolsMenu from './annotations/AnnotationToolsMenu.vue';
import Overlays from './Overlays.vue';
import VideoElement from './VideoPlayer.vue';

// #endregion Imports

export default {

  // #region Properties

  components: {
    AnnotationOverlay,
    AnnotationToolsMenu,
    Overlays,
    VideoElement
  },
  computed: {
    ...mapState([
      'video',
      'videoController',
      'ui'
    ]),
    mediaHasVideo() {
      return !!this.videoController?.mediaProperties?.videoProperties[0];
    },
    innerContainerStyle() {
      const style = {
        position: 'absolute',
        width:    '100%',
        height:   '100%',
        top:      '0px',
        left:     '0px'
      };

      if (!this.containerAspectRatio || !this.videoAspectRatio) {
        return style;
      }

      // Letterbox
      if (this.containerAspectRatio < this.videoAspectRatio) {
        const videoDisplayHeight = this.containerWidth / this.videoAspectRatio;
        style.height = `${videoDisplayHeight}px`;
        style.top = `${(this.containerHeight - videoDisplayHeight) / 2}px`;
      } 
      
      // Pillars
      else {
        const videoDisplayWidth = this.containerHeight * this.videoAspectRatio;
        style.width = `${videoDisplayWidth}px`;
        style.left = `${(this.containerWidth - videoDisplayWidth) / 2}px`;
      }

      return style;
    },
    containerAspectRatio() {
      if (!this.containerWidth || !this.containerHeight) {
        return undefined;
      }

      return (this.containerWidth / this.containerHeight);
    },
    videoAspectRatio() {
      if (!this.video.canPlay) {
        return undefined;
      }

      const videoWidth = this.video.element.videoWidth;
      const videoHeight = this.video.element.videoHeight;

      return (videoWidth / videoHeight);
    }
  },
  data() {
    return {
      sizeObserver:    undefined,
      containerWidth:  0,
      containerHeight: 0,
      videoWidth:      0,
      videoHeight:     0
    };
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.sizeObserver = new ResizeObserver(this.onContainerResized).observe(this.$refs.outer_container);
  },

  beforeDestroy() {
    if (this.sizeObserver) {
      this.sizeObserver.unobserve(this.$refs.outer_container);
    }
  },

  // #endregion Life-Cycle

  // #region Methods

  methods: {

    // #region Events

    onContainerResized() {
      if (this.$refs.outer_container) {
        this.containerWidth = this.$refs.outer_container.clientWidth;
        this.containerHeight = this.$refs.outer_container.clientHeight;
      } else {
        this.containerWidth = 0;
        this.containerHeight = 0;
      }
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.outer-container {
  width:      100%;
  height:     100%;
  position:   relative;

  .annotation-tools-menu {
    position:       absolute;
    top:            -56px;
    right:          0px;
    
    display:        flex;
    flex-direction: row;

    height:         48px;
    border-radius:  2px;

    background-color: #1e1e1e;
  }
}

.elements {
  width:        100%;
  height:       100%;
  position:     relative;

  .element {
    position:     absolute;
    width:        100%;
    height:       100%;
  }
}

</style>